import { EscalationLevelConfig } from '../models/configuration-row';

export interface EscalationConfigurationState {
  configurationId: number | null;
  escalationEnabled: boolean;
  escalationLevels: EscalationLevelConfig[];
  loading: boolean;
  saving: boolean;
  error: string | null;
  successMessage: string | null;
}

export const initialEscalationConfigurationState: EscalationConfigurationState = {
  configurationId: null,
  escalationEnabled: false,
  escalationLevels: [],
  loading: false,
  saving: false,
  error: null,
  successMessage: null,
};
